@if (isActive$ | async) {
  <div class="fixed top-0 left-0 right-0 z-50 h-1 bg-gray-200 dark:bg-gray-700 overflow-hidden">
    <div class="h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 animate-progress-bar"></div>
  </div>
}

<style>
  @keyframes progress-bar {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }

  .animate-progress-bar {
    animation: progress-bar 1.5s ease-in-out infinite;
    width: 50%;
  }
</style>
